<template>
  <v-text-field
    v-model="custom_filter"
    label="Ex. key:value"
    outlined
    dense
    @change="build_filter(custom_filter)"
  ></v-text-field>
</template>
<script>
import { createNamespacedHelpers } from "vuex-composition-helpers";
const uiStore = createNamespacedHelpers("ui");

export default {
  setup() {
    const { SHOW_DIALOG } = uiStore.useMutations(["SHOW_DIALOG"]);
    return { SHOW_DIALOG };
  },
  data: function () {
    return {
      custom_filter: null,
    };
  },
  methods: {
    build_filter(custom_filter) {
      const filter_array = custom_filter.split(":");
      if (filter_array != "" && filter_array.length != 2) {
        // check filter is formatted correctly
        this.SHOW_DIALOG({
          text: "custom filter should be formatted 'key:value'. Ex. 'user_id:12345'",
          color: "error",
        });
        return;
      }
      this.$emit("build_filter", {
        field: filter_array[0],
        value: filter_array[1],
      });
      this.custom_filter = "";
    },
  },
};
</script>
<style></style>
